
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import {HeadBar} from '@/components';
import {OrderProxy} from '@/http/RequestProxy.class';

const orderProxy = new OrderProxy();

export default {
name: 'plan-detail',
components: {
Flexbox,
FlexboxItem,
Swiper,
SwiperItem,
HeadBar,
XButton,
},
props: {













},
computed: {
lanType(){
return +window.localStorage.getItem('lan_type');
},
},
data(){
return {
data: this.$store.getters.getRoomPlanData,    // 房型数据


imgCurIdx: 1,
planIndex: 0,         // 当前方案的下标值
planData: {},         // 入住方案数据
renderPlan: false,    // 是否已经处理完方案数据标识别
params: {},
};
},





created(){
this.params = this.$route.query;
this.planIndex = this.$route.params.plan_index;
this.dealWithPlanData(this.data);
},





methods: {
/** 关闭房型弹层 */




/** 显示房型弹层 */




/** 获取轮播图下标值 */
onChangeImgIndex(currentIndex){
this.imgCurIdx = currentIndex;
},

/** 处理入住方案数据 */
dealWithPlanData(newData){
this.planData = newData.plan_list[this.planIndex];
this.renderPlan = true;











},

/** 显示条件取消内容 */
onShowCancelCondition(cancelContent){
this.$vux.alert.show({
content: cancelContent,
buttonText: this.$i18n.t('hotel.SHUT_DOWN'),
});
},

/** 查看当前房型的所有方案 */
onViewAll(){
this.onHidePopup();
this.$emit('on-expand-plan', this.planIndex, this.refName);
},

/** 预订酒店 */
onGotoBook(ev, roomTypeId, planId, roomPerson){
const hash = {
room_type_id: roomTypeId,
booking_plan_id: planId,
room_person: roomPerson,
};
const params = Object.assign({}, this.params, hash);
const _this = this;


orderProxy.checkLoginStatus()
.then(resp => {
if(resp.data.is_login){

orderProxy.priceChecker(params)
.then(resp => {
if (resp) {
if (Number(resp.code) === 30509) {
this.$vux.confirm.show({
content: resp.msg,
onConfirm () {
_this.$router.push({name: 'hotel-booking', query: params});
}
});
}else {
_this.$router.push({name: 'hotel-booking', query: params});

}
}
this.$vux.loading.hide();
});

}else{
const local = window.localStorage;
const curLocal = encodeURIComponent(window.location.href) + `?currency_code=${local.currency_code}&lan_type=${local.lan_name}`;

window.location.href = `${store.state.WAP_HOST}login.php?redirect_url=${curLocal}`;
}
});


ev.stopPropagation();


},
},
}



// WEBPACK FOOTER //
// ./src/views/hotel-detail/plan-detail.vue